import   {  ReactNode,  useEffect,   useState } from 'react';
 
import { useTranslation } from 'react-i18next';
 
import { ChevronDown } from 'icons/indexed-icons/IconChevronDown';
import { LegendItemContainer, ChartLegendContainer } from './ChartLegends.elements';
import { ChartLegendItemProps  } from './ChartLegends.types';
import { formatNumber } from 'common/helpers/formatNumber';
import { ConfigurableChartAndLegendProps, ConfigurableChartFormatProps } from 'common/components/ConfigurableLineChart';
 import useContainerSize from 'common/hooks/useContainerSize';
 
 /*
 
const detectOverflow = (container: HTMLDivElement | null, selector = `[data-id="Legenditem"]`) => {
  if (!container) return false;

  const items = container.querySelectorAll(selector);
  const containerRect = container.getBoundingClientRect();

  const containerWidth = containerRect.width;
  const legendItemsWidth = Array.from(items).reduce((total, item) => {
    const itemRect = item.getBoundingClientRect();
    return total + itemRect.width;
  }, 0);

  return legendItemsWidth > containerWidth

}

const setWidths = (selector = `[data-id="Legenditems"]`, parentRef?: RefObject<HTMLDivElement>) => {

}
*/
const Items = ({ data, colors, mapKeys, unit, format, disableClick = false, checkIfSelected, checkIfFiltered, handleClick, ...props }: { data?: ChartLegendItemProps[], format?: ConfigurableChartFormatProps } & ConfigurableChartAndLegendProps) => {
  const { groupKey, valueKey, labelKey } = props
  const label_key = labelKey || props?.label_key
  const value_key = valueKey || props?.value_key
  const grouping_key = groupKey || props?.grouping_key


  const { t } = useTranslation(['mh'])
 
  return <>
    {data?.map((item: ChartLegendItemProps, i: number, arr) => {
      
      let { value,  label, group, color} = item as ChartLegendItemProps & { color?: string, value?: ReactNode} || {}
      const id = label || group
      let className = `legend-item ${item?.className || ``}`.trim()
      const labelKeyToUse = ( label_key || grouping_key || item?.labelKey || value_key) as keyof ChartLegendItemProps

      value = (value || item?.[value_key as string] || item?.total || item?.count ) as ReactNode
      if (item?.[value_key as string] === 0) value = 0
      group =  item?.[labelKeyToUse] as ReactNode
      group = mapKeys?.[group as string] || group
      // first check before maps keys
      label = item?.[labelKeyToUse] || (mapKeys?.[group as string] || label  || !grouping_key && value_key ? value_key : group) as ReactNode
      color = colors?.[label as string] || (color || colors?.[label as string] || colors?.[group as string] || colors?.[value_key as string] || colors?.[grouping_key as string]) as string | undefined
 
      label = mapKeys?.[label as string] || label
      // check if color is set in the item, then check if color is set in the colors prop, then check if color is set in the mapKeys pro[]
      color =  color || (props?.color || item?.color || colors?.[label as string] || colors?.[group as string] )  as string | undefined
 
 
      if (typeof label === 'string') {
        className += ` legend-item--${label?.replace(/\s+/g, '-')}`
        label = t(label)
      }
      
      if (!label) return <></>

      const isSelected = checkIfSelected?.({ label, group, value, ...item, data: arr, dataIndex: i, legend: true })
      const isFiltered = checkIfFiltered?.({ label, group, value, ...item, data: arr, dataIndex: i, legend: true })

      if (isSelected) className += ' is-selected';
      if (isSelected === false) className += ' is-not-selected';

      if (isFiltered) className += ' is-filtered';
      if (isFiltered === false) className += ' is-not-filtered';
 
      group = format?.legendItems?.({ group: label, grouping_key, value_key, data: item, arr, dataIndex: i, props }) || group as ReactNode
      label = format?.legendItems?.({ label,  grouping_key, value_key,data: item, arr, dataIndex: i, props }) || label as ReactNode
      unit = format?.legendItems?.({ unit,  grouping_key, labelKey, value_key,data: item, arr, dataIndex: i, props }) || unit
      value = format?.legendItems?.({ value,  grouping_key, labelKey, value_key,data: item, arr, dataIndex: i, props }) || formatNumber(value)
       

      if (label === '') label = undefined
      if (group === '') group = undefined
      if (value === '' || value === undefined) value = undefined
      if (typeof value === 'string') value =  `(${!unit ? value : unit === '%' ? `${value}${unit}` : `${value} ${unit}`})`

      return (
        <LegendItemContainer
          key={i}
          onClick={() => !disableClick && handleClick?.({ ...item, arr, dataIndex: i, legend: true })}
          className={className}
          color={color as string}
          data-index={i}
          data-id='legenditem'
          data-group={label}
          data-legenditem={id}
        >
          {(label) && <div className='legend-label'>{label} </div>}
          {(value) && <div className='sub-text value'>{value}</div>}
        </LegendItemContainer>
      );

    })} 
  </>
};

export const  ChartLegendWithAutoDropdown = ({
  legendItems,
  className, 
  ...props
}: ConfigurableChartAndLegendProps & { format?: ConfigurableChartFormatProps}): JSX.Element => {
 
  if (!legendItems || !props) return <></>

 

  const formatLegendItems = props?.format?.legendItems as ((x: Record<string, unknown>) => ChartLegendItemProps[] | undefined)
  legendItems = formatLegendItems?.({legendItems, props}) || legendItems
  className = `chart-legend ${className || ''}`.trim()
 
  const { width, containerRef } = useContainerSize()

  const [legend, setLegend] = useState<{inline?:ChartLegendItemProps[], dropdown?:ChartLegendItemProps[], isInit: boolean}>({
    inline: undefined,
    dropdown: undefined,
    isInit: false
  })

  const isInit = legend?.isInit

  useEffect(() => {
    setLegend({ inline: undefined, dropdown: undefined, isInit: false })
  }, [width, legendItems ])

  useEffect(() => {

    if (isInit) return 

    let widthCounter = 0

    let inline = undefined as ChartLegendItemProps[] | undefined
    let dropdown = undefined as ChartLegendItemProps[] | undefined

    containerRef?.current?.querySelectorAll(`[data-id="legenditem"]`)?.forEach((el ) => {
      const itemWidth = Math.ceil(el?.getBoundingClientRect().width || 0)
      const dataId = el.dataset.index
      
      if ((widthCounter + itemWidth) < width) inline = [...(inline || []), legendItems?.[Number(dataId)]]
      else dropdown = [...(dropdown || []), legendItems?.[Number(dataId)]]
      widthCounter += itemWidth
    })

    setLegend({ inline, dropdown, isInit: true })

  }, [legend?.isInit])
 
  if (legend?.dropdown) className += ' has-dropdown'
  
  return (
    <ChartLegendContainer className={className} ref={containerRef} data-init={legend?.isInit}>
      <div className='inline-legend-items' data-id='legenditems'>
        <Items {...{...props, data: legend?.inline || legendItems }} />
      </div>
      {<div className='dropdown-btn'>
        <div className='ico'>
          ...
          <ChevronDown />
        </div>
        <div className='dropdown-area'>
          <div className='scroll-mask' data-id='dropdownarea'>
            {legend?.dropdown && <Items {...{...props, data: legend?.dropdown}} />}
          </div>
        </div>
      </div>}
    </ChartLegendContainer>
  );
};

export default ChartLegendWithAutoDropdown

// <ChartLegendWithAutoDropdownItemContainer key={i} color={props?.color as string}>{props?.label as string|| ''}</ChartLegendWithAutoDropdownItemContainer>
